import { WidgetDef } from '../../../types';

/**
 * Canonical widgets for the `projects` page. Each `widgetId` is the stable id
 * used by `AccountCustomization#content.widgets.projects[].widgetId` in upstack_api.
 *
 * Cross-repo coupling: when adding/renaming/removing a widget here, mirror the
 * change in upstack_api at `app/models/account_customization.rb`
 * (`AccountCustomization::WIDGET_CATALOG["projects"]`) and bump the count
 * assertion in `spec/models/account_customization_spec.rb`. See `docs/mcp.md`
 * in upstack_api for the protocol.
 */
export const ProjectWidgetDefs: WidgetDef[] = [
  { widgetId: 'projectStatus', headerName: 'Project Status', index: 0, hide: false, disabled: false },
  { widgetId: 'keyDates', headerName: 'Key Dates', index: 1, hide: false, disabled: false },
  { widgetId: 'projectPipeline', headerName: 'Project Pipeline', index: 2, hide: false, disabled: false }
];
